import './landing.css';


const Hero = () => {
  return (
    <div className="Hero" >
      <div className='section'>
        <div className="heroSection" >
          <h1 className="bodayHigh" >Hello 👋<span style={{ display: 'block' }} />
            I’m <span style={{ fontWeight: 'normal' }} >Helal Atef </span>Sr. UX/UI Designer

          </h1>
        </div>
      </div>
    </div>
  );
}

export default Hero;
